import {useEffect, useState} from 'react';

// FNP-1879: the search input (TableSearchForm in RecordsTable) and the list hook that
// filters are separate hook instances, and ReloadRecordsButton mounts a third. A local
// useState gives each its own keyword copy, which is how search did nothing here before.
// Module-scoped store, every caller subscribes (global-filter-store-pattern, FNP-815).
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

export const useBillableEventsSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => setKeyword(newKeyword);
        keywordListeners.add(listener);
        // FNP-605: a change made between this component's render and this effect would
        // otherwise be missed, so re-read the store once subscribed.
        setKeyword(globalKeyword);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {keyword, handleFilterByKeyword};
};
